class EnMessages {
   public notAllowedToDistribute: string = 'You magician! You\'re not allowed to generate money by claiming more than there is available';
}

export const enMessages = new EnMessages();
